import { useViewSize, ViewSize } from "@/hooks/useViewSize";

export function ViewSizeIndicator() {
  const viewSize = useViewSize();

  // Only show in development mode
  if (import.meta.env.PROD) {
    return null;
  }

  const labels: Record<ViewSize, string> = {
    xs: "XS",
    sm: "SM",
    md: "MD",
    lg: "LG",
    xl: "XL",
    "2xl": "2XL",
  };

  return (
    <div className="fixed top-2 right-2 z-[100] bg-muted text-muted-foreground text-xs px-2 py-1 rounded-md font-mono pointer-events-none">
      {labels[viewSize]}
    </div>
  );
}
